<template>
  <Page
    v-if="user"
    title="Dashboard"
    subtitle="Account overview"
    :hide-sidebar="false"
    :loading="loading"
    :data-dashboard-user-id="user ? user.id : '0'"
    authenticated
    no-headers
    :data-verification-pending="
      user && user.verified === UserDtoVerifiedEnum.PENDING ? '1' : '0'
    "
    no-breadcrumbs
  >
    <template #settings-bar>
      <div class="flex-1">
        <DashMetrics />
      </div>
    </template>
    <!-- alerts -->
    <!-- content -->
    <ContentSection>
      <CardGrouping size="xl">
        <SubscriptionAlert />
        <UnverifiedDomainAlert />
        <Card flush data-id="dashboard-card" :data-active-tab="defaultTab">
          <Tabs
            :default-tab="defaultTab"
            :has-changed="hasChangedTab ? '1' : '0'"
          >
            <Tab :title="'API access'" test-id="dashboard-api" no-body>
              <GettingStartedCard />
            </Tab>
            <Tab title="SMTP/IMAP" test-id="dashboard-smtp" no-body>
              <SmtpImapAccessView :inbox-id="undefined" />
            </Tab>
            <Tab
              :title="'Connect mailbox'"
              test-id="dashboard-connectors"
              no-body
            >
              <CreateConnectorConnectionsCard no-card />
            </Tab>
            <Tab :title="'Invite team'" test-id="dashboard-team" no-body>
              <OrganizationsTable no-card />
              <PortalsTable no-card />
            </Tab>
          </Tabs>
        </Card>

        <Card
          flush
          data-id="dashboard-entities-card"
          :data-active-tab="defaultTab"
        >
          <Tabs>
            <Tab title="Emails" test-id="dashboard-emails" no-body>
              <EmailsTable no-card show-inbox-selector />
            </Tab>
            <Tab title="SMS" test-id="dashboard-sms" no-body>
              <SmsTable no-card show-phone-selector />
            </Tab>
          </Tabs>
        </Card>
      </CardGrouping>
    </ContentSection>
    <!-- tabs -->
    <!--    <template #onboarding>-->
    <!--      <OnboardingWelcome />-->
    <!--    </template>-->
  </Page>
</template>
<script setup lang="ts">
import Tabs from '../components/form/Tabs.vue';
import Tab from '../components/form/Tab.vue';
import Page from '../components/Page.vue';
import ContentSection from '../components/ContentSection.vue';
import GettingStartedCard from '../components/card/GettingStartedCard.vue';
import SubscriptionAlert from '../components/alerts/SubscriptionAlert.vue';
import OnboardingWelcome from '../components/onboarding/OnboardingWelcome.vue';
import UnverifiedDomainAlert from '../components/alerts/UnverifiedDomainAlert.vue';
import { onMounted, ref } from 'vue';

import { useStore3 } from '../store/main';
import { storeToRefs } from 'pinia';
import Card from '../components/tw/Card.vue';
import CardGrouping from '../components/tw/CardGrouping.vue';
import { UserDtoVerifiedEnum } from '@mailslurp/admin-sdk';
import SmtpImapAccessView from '../pages/home/SmtpImapAccessView.vue';
import DashMetrics from '../components/card/metrics/DashMetrics.vue';
import OrganizationsTable from '../components/table/OrganizationsTable.vue';
import CreateConnectorConnectionsCard from '../components/card/connectors/CreateConnectorConnectionsCard.vue';
import { navigateTo } from '#imports';
import EmailsTable from '../components/table/EmailsTable.vue';
import SmsTable from '../components/table/SmsTable.vue';
import PortalsTable from '../components/table/PortalsTable.vue';
import { getLogger } from '../lib/services/getLogger';

const log = getLogger('Dashboard');
const loading = ref(false);
const tabApiAccess = 0;
const defaultTab = ref(tabApiAccess);
const hasChangedTab = ref(false);
const store3 = useStore3();

const { user, dashboardLoaded } = storeToRefs(store3);

onMounted(async () => {
  log('Dash created');
  const plan = store3.getRequestedPlanAndClear();
  log('Got plan from store ' + plan);
  if (plan) {
    log('Upgrade to requested plan');
    await navigateTo('/upgrade/' + plan);
    return;
  }
  dashboardLoaded.value = true;
});
</script>
